import { Link } from 'react-router-dom'

const MainPage = () => {

    return (
        <>
            <div className="light-theme">
                <div className="section1 position-relative">
                    <div className="overlay padding text-center h-100 d-flex flex-column justify-content-center">
                        <div className="container">
                            <div className="login-box mx-auto">
                                <div>
                                    <Link to="/park"><img src={require('../assets/images/battle_club_logo.PNG')} alt="" className="img-fluid mb-5" style={{ "width": "110px" }} /></Link>
                                </div>
                                <div>
                                    <Link to="/limits"><img src={require('../assets/images/logo.png')} alt="" className="img-fluid" style={{ "width": "150px" }} /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MainPage
